import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Typography
} from '@mui/material';

import resource from '../../../../../../assets/images/resources.png';

const UpgradePlan = ({ className, ...rest }) => {
  return (
    <Box
      {...rest}
      className={clsx(className)}
      sx={{
        bgcolor: 'grey.50'
      }}
    >
      <Box
        sx={{
          pt: 2,
          height: 80,
          textAlign: 'center',
          '& img': {
            height: '100%',
            width: 'auto'
          }
        }}
      >
        <img
          alt="Upgrade to PRO"
          src={resource}
        />
      </Box>

      <Box
        sx={{
          px: 2,
          py: 1
        }}
      >
        <Typography
          align="center"
          gutterBottom
          variant="h6"
        >
          Want to learn more?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Click here to go to our exclusive Resource Centre.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          px: 2,
          py: 1
        }}
      >
        <Button
          color="primary"
          component="a"
          href="#"
          size="small"
          sx={{
            textTransform: 'capitalize'
          }}
          variant="contained"
        >
          Resource Centre
        </Button>
      </Box>
    </Box>
  );
};

UpgradePlan.propTypes = {
  className: PropTypes.string
};

export default UpgradePlan;